import React from "react";
import { STACK_TYPES, normalizeBounds, stackBoundsIssue, stacksEnabled } from "@/lib/rawStacks";

const numCls = "w-16 bg-black border border-zinc-800 focus:border-[#39FF14] outline-none px-2 py-1 text-center text-[11px] mono";

export const StackBoundsCard = ({ cfg, setCfg }) => {
  const bounds = normalizeBounds(cfg.stack_bounds);
  const issue = stackBoundsIssue(bounds);
  const n = Number(cfg.num_lineups) || 0;
  const setBound = (key, field, raw) => {
    const v = raw === "" ? (field === "max" ? 100 : 0) : Math.max(0, Math.min(100, Number(raw) || 0));
    setCfg({ ...cfg, stack_bounds: { ...bounds, [key]: { ...bounds[key], [field]: v } } });
  };
  return (
    <div className="border border-zinc-800 bg-[#0e0e0e] p-3" data-testid="raw-stack-bounds">
      <div className="mono text-[11px] font-black uppercase tracking-widest text-white mb-1">Stack shapes · min / max share</div>
      <div className="mono text-[9px] uppercase tracking-widest text-zinc-500 mb-3">
        % of your {n || "N"} lineups each shape may take · the build lands inside every range
      </div>
      <table className="w-full">
        <thead>
          <tr className="mono text-[9px] uppercase tracking-widest text-zinc-500">
            <th className="text-left pb-1 font-normal">Shape</th>
            <th className="pb-1 font-normal">Min %</th>
            <th className="pb-1 font-normal">Max %</th>
            <th className="pb-1 font-normal text-right">Lineups</th>
          </tr>
        </thead>
        <tbody>
          {STACK_TYPES.map((t) => {
            const v = bounds[t.key];
            return (
              <tr key={t.key} className="border-t border-zinc-900" data-testid={`raw-stack-row-${t.tid}`}>
                <td className="py-1.5">
                  <div className="mono text-[11px] text-white font-bold">{t.label}</div>
                  <div className="mono text-[9px] text-zinc-500">{t.sub}</div>
                </td>
                <td className="py-1.5 text-center">
                  <input type="number" min="0" max="100" step="5" value={v.min} className={numCls} data-testid={`raw-stack-min-${t.tid}`}
                         onChange={(e) => setBound(t.key, "min", e.target.value)} />
                </td>
                <td className="py-1.5 text-center">
                  <input type="number" min="0" max="100" step="5" value={v.max} className={numCls} data-testid={`raw-stack-max-${t.tid}`}
                         onChange={(e) => setBound(t.key, "max", e.target.value)} />
                </td>
                <td className="py-1.5 text-right mono text-[10px] text-zinc-400">
                  {n ? `${Math.ceil((n * v.min) / 100)}–${Math.floor((n * v.max) / 100)}` : "—"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className={`mono text-[9px] uppercase tracking-widest mt-2 ${issue ? "text-[#FFCC00]" : "text-[#39FF14]"}`} data-testid="raw-stack-bounds-status">
        {issue || "Ranges are solvable"}
      </div>
      <label className={`flex items-center gap-2 mt-3 pt-2 border-t border-zinc-900 ${stacksEnabled(bounds) ? "" : "opacity-40 pointer-events-none"}`}>
        <input type="checkbox" checked={!!cfg.bring_back} onChange={(e) => setCfg({ ...cfg, bring_back: e.target.checked })}
               data-testid="raw-bring-back" className="w-4 h-4 accent-[#39FF14] cursor-pointer" />
        <div className="mono text-[10px] uppercase tracking-widest text-zinc-300">
          Bring-Back · one opposing WR/TE on every stacked lineup
        </div>
      </label>
    </div>
  );
};

export default StackBoundsCard;
